module.exports = __webpack_public_path__ + "static/boronia-6f3fd0ccdc4d19e4faf7ecdd97c5906c.jpeg";